import { LoaderIcon } from "lucide-react"

import { Button, type ButtonProps } from "@/components/ui/button"
type LoaderButtonProps = ButtonProps & {
  isLoading?: boolean
}
export const LoaderButton = ({
  isLoading,
  children,
  ...props
}: LoaderButtonProps) => {
  return (
    <Button {...props}>
      {isLoading && <LoaderIcon className="mr-2 animate-spin" />}
      {children}
    </Button>
  )
}
